// 西アジア・中央アジアの世界史スポット。
// メソポタミア文明、オリエントの統一、一神教の成立、イスラーム帝国、そして
// 東西を結ぶ隊商都市を代表させる。
//
// エルサレムは主権が国際的に未確定なため country に国名を書かず、解説も三宗教の
// 聖地であることの記述に徹して現代の政治的主張には立ち入らない。

export const WEST_ASIA_SITES = [
  {
    id: 'ur-ziggurat',
    name: 'ウルのジッグラト',
    nameEn: 'Ziggurat of Ur',
    lat: 30.9626, lng: 46.1031, elevationM: 15,
    region: 'west-asia', era: 'ancient',
    country: 'イラク（ジーカール県）',
    civilization: 'シュメール（ウル第3王朝）',
    yearLabel: '前21世紀頃',
    whcYear: 2016,
    whcNote: '「南イラクのアフワール」の一部',
    emoji: '🏛',
    summary:
      'ティグリス・ユーフラテス両河の下流に栄えたシュメール人の都市国家ウルに、前21世紀頃のウル第3王朝が築いた聖塔。日干し煉瓦を階段状に積み上げ、頂に月神ナンナの神殿を戴いていた。シュメール人は灌漑農業で余剰を生み、粘土板に楔形文字を刻んで記録と法を残し、六十進法や太陰暦を発達させた。都市の中心にそびえる神殿は、神官が水利と穀物を管理する神権政治の姿を今に伝える。旧約聖書がアブラハムの出身地とする「カルデアのウル」も、この地に比定されている。',
    quiz: {
      statement: 'シュメール人は楔形文字を発明し、粘土板に記録を残した。',
      answer: true,
      explain: '楔形文字は葦の尖筆で粘土板に刻む文字で、シュメール人が発明しました。のちアッカド語やヒッタイト語など、多くの言語の表記に用いられます。',
    },
  },
  {
    id: 'babylon',
    name: 'バビロン遺跡',
    nameEn: 'Babylon',
    lat: 32.5423, lng: 44.4210, elevationM: 35,
    region: 'west-asia', era: 'ancient',
    country: 'イラク（バービル県）',
    civilization: '古バビロニア／新バビロニア',
    yearLabel: '前18世紀（ハンムラビ王）／前6世紀（ネブカドネザル2世）',
    whcYear: 2019,
    emoji: '🏛',
    facts: [
      { label: '現況', value: '20世紀の復元と近年の戦災で改変が大きい' },
    ],
    summary:
      'ユーフラテス川のほとりに栄えた古代メソポタミアの中心都市。前18世紀には古バビロニアのハンムラビ王がメソポタミアを統一し、「目には目を」の同害復讐で知られる法典を石柱に刻ませた。前6世紀の新バビロニアではネブカドネザル2世がユダ王国を滅ぼしてバビロン捕囚を行い、青い彩釉煉瓦のイシュタル門や「空中庭園」の伝説を残した。前539年にアケメネス朝ペルシアのキュロス2世に征服され、捕囚のユダヤ人は解放される。オリエント世界が統合へ向かう転換点である。',
    quiz: {
      statement: 'ハンムラビ法典は、身分にかかわらずすべての人に同じ刑罰を定めていた。',
      answer: false,
      explain: '「目には目を」の同害復讐が有名ですが、適用は身分によって異なりました。奴隷や平民に対する加害は、賠償金で済まされる場合があります。',
    },
  },
  {
    id: 'hattusa',
    name: 'ハットゥシャ（ヒッタイト王国首都）',
    nameEn: 'Hattusa',
    lat: 40.0197, lng: 34.6153, elevationM: 1000,
    region: 'west-asia', era: 'ancient',
    country: 'トルコ（チョルム県）',
    civilization: 'ヒッタイト',
    yearLabel: '前17〜前12世紀',
    whcYear: 1986,
    emoji: '🏛',
    summary:
      'アナトリア高原に興ったヒッタイト王国の首都。前16世紀にはバビロン第1王朝（古バビロニア）を滅ぼし、前13世紀にはエジプト新王国のラメセス2世とカデシュで戦って、現存する世界最古級の国際条約を結んだ。ヒッタイトは鉄器の製法をいち早く実用化したことで知られ、その独占が崩れる前12世紀の「海の民」の動乱以降、鉄器はオリエント全域に広まっていく。城塞をめぐる城壁と獅子門・王の門が残り、出土した粘土板文書からインド・ヨーロッパ語族の言語であることが判明した。',
    quiz: {
      statement: 'ヒッタイトはいち早く鉄器を実用化し、その技術は前12世紀以降オリエント全域に広まった。',
      answer: true,
      explain: 'ヒッタイトは鉄の製法を管理していましたが、王国が「海の民」の動乱で崩れると技術が拡散し、オリエントは本格的な鉄器時代に入りました。',
    },
  },
  {
    id: 'troy',
    name: 'トロイ遺跡',
    nameEn: 'Troy',
    lat: 39.9575, lng: 26.2389, elevationM: 35,
    region: 'west-asia', era: 'ancient',
    country: 'トルコ（チャナッカレ県）',
    civilization: 'エーゲ文明',
    yearLabel: '前3000年頃〜後1世紀（9層の都市が重なる）',
    whcYear: 1998,
    emoji: '🏛',
    summary:
      'ダーダネルス海峡を望む丘に、前3000年頃から幾度も築き直された都市の遺跡。ホメロスの叙事詩『イリアス』が語るトロイア戦争の舞台とされ、19世紀にドイツのシュリーマンが叙事詩を手がかりに発掘して世界を驚かせた。ただし彼が「プリアモスの財宝」と呼んだ出土品は、実際には想定よりはるかに古い層のものだったことが後の調査で分かっている。9層に重なる都市の層位は、伝説と考古学がどう交わり、どうずれるかを示す教科書的な事例となった。',
    quiz: {
      statement: 'シュリーマンがトロイで発見した「プリアモスの財宝」は、トロイア戦争と同じ時代の層から出土したものだった。',
      answer: false,
      explain: '後の調査で、その財宝は想定よりはるかに古い層のものと判明しました。シュリーマンは目的の層まで掘り下げる過程で、上の層を壊してもいます。',
    },
  },
  {
    id: 'persepolis',
    name: 'ペルセポリス',
    nameEn: 'Persepolis',
    lat: 29.9354, lng: 52.8916, elevationM: 1600,
    region: 'west-asia', era: 'ancient',
    country: 'イラン（ファールス州）',
    civilization: 'アケメネス朝ペルシア',
    yearLabel: '前518年頃 造営開始（ダレイオス1世）',
    whcYear: 1979,
    emoji: '🏛',
    summary:
      'アケメネス朝ペルシアのダレイオス1世が前518年頃から築いた儀礼用の都。エジプトからインダス川に至る広大な領域を、サトラップ（知事）と「王の目・王の耳」による監察、そして「王の道」と駅伝制で統治した帝国の象徴である。謁見の間アパダーナの階段には、各地から貢納品を運ぶ23の民族の行列が浮彫にされ、多様な民族と宗教を許容した統治のかたちを伝える。前330年、アレクサンドロス大王の東方遠征によって焼き払われ、ヘレニズム時代の幕が開いた。',
    quiz: {
      statement: 'ペルセポリスは、アレクサンドロス大王の東方遠征のさなかに焼き払われた。',
      answer: true,
      explain: '前330年、アレクサンドロス軍がペルセポリスを占領して炎上させました。アケメネス朝はまもなく滅び、オリエントとギリシアが融け合うヘレニズム時代が始まります。',
    },
  },
  {
    id: 'petra',
    name: 'ペトラ',
    nameEn: 'Petra',
    lat: 30.3222, lng: 35.4515, elevationM: 900,
    region: 'west-asia', era: 'ancient',
    country: 'ヨルダン（マアーン県）',
    civilization: 'ナバテア王国',
    yearLabel: '前1世紀〜後2世紀に最盛',
    whcYear: 1985,
    emoji: '🏛',
    summary:
      '砂岩の峡谷シークを抜けた先に、岩壁を直接彫り込んで造られた隊商都市。アラビア半島の乳香・没薬を地中海世界へ運ぶ交易路を押さえたナバテア人が築き、前1世紀から後2世紀にかけて最も栄えた。切り立った岩に刻まれたエル・ハズネ（宝物殿）の正面には、ヘレニズム建築の円柱と破風がそのまま現れており、東西の様式が交わった場所であることを物語る。乾燥地でありながらダムと水路で水を確保した技術も特筆される。106年にローマ帝国に併合された。',
    quiz: {
      statement: 'ペトラの建造物は、石材を積み上げるのではなく、岩壁を直接彫り抜いて造られている。',
      answer: true,
      explain: 'エル・ハズネなどの主要な建造物は、砂岩の岩壁を上から彫り下げて造られました。内部の空間も同じ岩をくり抜いたものです。',
    },
  },
  {
    id: 'palmyra',
    name: 'パルミラ',
    nameEn: 'Palmyra',
    lat: 34.5520, lng: 38.2740, elevationM: 400,
    region: 'west-asia', era: 'ancient',
    country: 'シリア（ホムス県）',
    civilization: '隊商都市／ローマ帝国',
    yearLabel: '1〜3世紀に最盛',
    whcYear: 1980,
    emoji: '🏛',
    facts: [
      { label: '現況', value: '2015年以降の紛争で一部が破壊された' },
    ],
    summary:
      'シリア砂漠のオアシスに立つ隊商都市。ローマ帝国とパルティア（のちササン朝）という二大勢力の狭間で、東方の絹や香料を地中海へ運ぶ中継貿易によって1〜3世紀に大きく栄えた。列柱街路やベル神殿には、ギリシア・ローマの様式とオリエントの意匠が同居している。3世紀には女王ゼノビアがローマからの自立をはかりエジプトまで勢力を伸ばしたが、皇帝アウレリアヌスに敗れて都市は衰退した。2015年以降の紛争で遺跡の一部が破壊されている。',
    quiz: {
      statement: '3世紀のパルミラは女王ゼノビアのもとでローマからの自立をはかり、一時はエジプトまで勢力を広げた。',
      answer: true,
      explain: 'ゼノビアは「軍人皇帝時代」の混乱に乗じて勢力を拡大しましたが、272年に皇帝アウレリアヌスに敗れ、パルミラは急速に衰えました。',
    },
  },
  {
    id: 'jerusalem-old-city',
    name: 'エルサレム旧市街',
    nameEn: 'Old City of Jerusalem',
    lat: 31.7780, lng: 35.2354, elevationM: 740,
    region: 'west-asia', era: 'ancient',
    country: 'エルサレム',
    civilization: 'ユダヤ教・キリスト教・イスラームの聖地',
    yearLabel: '前10世紀頃〜現在',
    whcYear: 1981,
    whcNote: '「エルサレムの旧市街とその城壁群」（ヨルダンによる申請）',
    emoji: '🕍',
    summary:
      '三つの一神教が聖地とする、世界史でも稀有な場所。ユダヤ教では、前10世紀頃にソロモン王が神殿を築いた丘であり、その擁壁の一部とされる「嘆きの壁」が祈りの場となっている。キリスト教では、イエスが処刑され復活したとされる場所に聖墳墓教会が立つ。イスラームでは、預言者ムハンマドが夜の旅で昇天したと伝えられる岩の上に、7世紀末の岩のドームが建てられた。11世紀末から始まる十字軍をはじめ、この街の帰属は繰り返し争いの焦点となってきた。',
    quiz: {
      statement: 'エルサレムはユダヤ教・キリスト教・イスラームの三つの宗教にとっての聖地である。',
      answer: true,
      explain: 'ユダヤ教は神殿の丘と嘆きの壁、キリスト教は聖墳墓教会、イスラームは岩のドームを聖地とし、いずれも旧市街の狭い区域に集まっています。',
    },
  },
  {
    id: 'umayyad-mosque',
    name: 'ウマイヤ・モスク（ダマスクス）',
    nameEn: 'Umayyad Mosque',
    lat: 33.5117, lng: 36.3067, elevationM: 690,
    region: 'west-asia', era: 'medieval',
    country: 'シリア（ダマスクス）',
    civilization: 'ウマイヤ朝',
    yearLabel: '705〜715年 建立',
    whcYear: 1979,
    whcNote: '「古都ダマスクス」の一部',
    emoji: '🕌',
    summary:
      'ウマイヤ朝のカリフ、ワリード1世が705年から建てた初期イスラーム建築の代表作。661年にムアーウィヤがダマスクスを都に開いたウマイヤ朝は、西は北アフリカからイベリア半島、東は中央アジアに及ぶ大帝国を築き、カリフ位を世襲化した。もとはローマ神殿、次いでキリスト教の聖堂だった場所に建てられており、モザイクや列柱にはビザンツの技術が生かされている。アラブ人を優遇し非アラブ改宗者（マワーリー）に税を課した体制は、750年のアッバース朝の革命で覆された。',
    quiz: {
      statement: 'ウマイヤ朝はバグダードを都とし、民族を問わず平等な税制を敷いた。',
      answer: false,
      explain: 'ウマイヤ朝の都はダマスクスです。アラブ人を優遇し、非アラブの改宗者にも税を課しました。バグダードを都とし税制を改めたのは、次のアッバース朝です。',
    },
  },
  {
    id: 'hagia-sophia',
    name: 'アヤソフィア',
    nameEn: 'Hagia Sophia',
    lat: 41.0086, lng: 28.9802, elevationM: 40,
    region: 'west-asia', era: 'medieval',
    country: 'トルコ（イスタンブル）',
    civilization: 'ビザンツ帝国 → オスマン帝国',
    yearLabel: '537年 完成（ユスティニアヌス1世）',
    whcYear: 1985,
    whcNote: '「イスタンブル歴史地区」の一部',
    emoji: '🕌',
    facts: [
      { label: 'ドーム', value: '直径 約31m / 床から 約56m' },
      { label: '用途の変遷', value: '聖堂 → モスク → 博物館 → モスク' },
    ],
    summary:
      '537年、ビザンツ帝国の皇帝ユスティニアヌス1世がコンスタンティノープルに完成させた大聖堂。直径約31mの巨大なドームを四隅のペンデンティヴで支える構造は当時の建築技術の頂点で、内部は黄金地のモザイクで飾られた。1054年の東西教会の分裂後はギリシア正教会の中心となったが、1453年にオスマン帝国のメフメト2世がコンスタンティノープルを陥落させると、破壊されずにモスクへ転用され、ミナレットが加えられた。1935年に博物館となり、2020年に再びモスクとなっている。',
    quiz: {
      statement: 'オスマン帝国はコンスタンティノープルを征服したあと、アヤソフィアを取り壊した。',
      answer: false,
      explain: '1453年に征服したメフメト2世は、アヤソフィアを破壊せずモスクに転用しました。キリスト教のモザイク画は漆喰で覆われる形で保存され、20世紀の修復で再び現れました。',
    },
  },
  {
    id: 'selimiye-mosque',
    name: 'セリミエ・モスク（エディルネ）',
    nameEn: 'Selimiye Mosque, Edirne',
    lat: 41.6783, lng: 26.5594, elevationM: 55,
    region: 'west-asia', era: 'earlymodern',
    country: 'トルコ（エディルネ県）',
    civilization: 'オスマン帝国',
    yearLabel: '1568〜1574年（建築家ミマール・スィナン）',
    whcYear: 2011,
    emoji: '🕌',
    summary:
      'オスマン帝国の旧都エディルネに、宮廷建築家ミマール・スィナンが80歳を過ぎて完成させた最高傑作。アヤソフィアを超える直径のドームを4本の柱で支え、内部に柱の林立しない一体の礼拝空間を実現した。ビザンツ建築を受け継ぎつつ乗り越えたオスマン建築の到達点である。オスマン帝国はスレイマン1世の時代に最盛期を迎え、1529年の第一次ウィーン包囲でヨーロッパを震撼させた。ミッレト制のもとでキリスト教徒やユダヤ教徒に共同体としての自治を認めた多民族統治も、この時代のかたちである。',
    quiz: {
      statement: 'オスマン帝国のイェニチェリは、征服地のキリスト教徒の子弟を徴用して育てた常備歩兵軍団である。',
      answer: true,
      explain: 'デヴシルメと呼ばれる制度で徴用された少年たちがイスラームに改宗し、訓練を受けてスルタン直属の精鋭部隊イェニチェリとなりました。',
    },
  },
  {
    id: 'registan-samarkand',
    name: 'レギスタン広場（サマルカンド）',
    nameEn: 'Registan, Samarkand',
    lat: 39.6547, lng: 66.9758, elevationM: 705,
    region: 'west-asia', era: 'medieval',
    country: 'ウズベキスタン（サマルカンド州）',
    civilization: 'ティムール朝',
    yearLabel: '15〜17世紀（ウルグ・ベク・マドラサは1420年）',
    whcYear: 2001,
    whcNote: '「サマルカンド－文化交差路」の一部',
    emoji: '🕌',
    summary:
      'シルクロードの要衝サマルカンドの中心に、三つのマドラサ（学院）が向かい合う広場。14世紀後半に中央アジアを統一したティムールは、この街を都として各地から職人を集め、青いタイルに覆われた建築群を築いた。孫のウルグ・ベクは自ら天文台を建てて精密な星表を作り、学問の庇護者としても知られる。ティムール朝はモンゴル帝国の遺産を受け継ぎつつイラン・イスラーム文化と融合し、その様式はのちにインドのムガル帝国へと流れ込んでいく。',
    quiz: {
      statement: 'サマルカンドを都としたティムールの孫ウルグ・ベクは、天文台を建てて精密な星表を作らせた。',
      answer: true,
      explain: 'ウルグ・ベクはサマルカンドに大規模な天文台を築き、当時としてはきわめて精密な星表を編纂しました。彼自身が優れた天文学者でもありました。',
    },
  },
];
